export default __webpack_public_path__ + "static/media/setPrivilages.e8608cb8.jpg";